import React from 'react'

import { Button, Avatar, TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func, shape, bool } from 'prop-types'

const imageProps = {
  loading: 'lazy',
  decoding: 'async',
}

function ReplyForm({ replyContent, onReplyContentChange, onSubmit, userAvatar = null, username, isLoading = false }) {
  return (
    <div className="rating__reply-form">
      {(userAvatar?.small?.url || username) && (
        <Avatar
          size="40"
          img={userAvatar?.small?.url}
          username={username}
          imageProps={imageProps}
        />
      )}
      <TextInput
        id="reply-input"
        placeholder="Write your reply here"
        value={replyContent}
        onChange={onReplyContentChange}
        size="medium"
        isPilot
        type="primary"
        textInputClassName="rating__reply-input"
        wrapperClassName="rating__reply-input-wrapper"
        isNotSpaced
      />
      <Button
        type="primary"
        actionType="button"
        onClick={onSubmit}
        disabled={!replyContent.trim() || isLoading}
      >
        {isLoading ? 'Posting...' : 'Post'}
      </Button>
    </div>
  )
}

ReplyForm.propTypes = {
  replyContent: string.isRequired,
  onReplyContentChange: func.isRequired,
  onSubmit: func.isRequired,
  username: string.isRequired,
  isLoading: bool,
  userAvatar: shape({
    small: shape({
      url: string,
    }),
    url: string,
  }),
}

export default ReplyForm
